export const paths = {
    admin: 'admin',
    contactus: 'contact-us',
    cookies: 'cookies',
    firebaseinfo: 'firebase-info',
    home: 'home',
    login: 'login',
    notfound: 'not-found',
    privacy: 'privacy',
  }